import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { FuseWidgetModule } from '../../../../../@fuse/components/widget/widget.module';
import { Gt2LocaleService } from '../../../../localization/gt2-locale.service';
import { CrudOrganizationComponent } from './crud-organization.component';
import { CrudOrganizationService } from './crud-organization.service';
import { CrudOrganizationIdentityComponent } from '../crud-organization-identity/crud-organization-identity.component';
import { AppRoutesName } from '../../../const/AppRoutesName';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DisplayHtmlLinkPipeModule } from '../../../modules/display-html-link.module';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AddressComponent } from '../../../components/address/address.component';
import { ContactComponent } from '../../../components/contact/contact.component';
import { SignatureRichEditorComponent } from '../../../components/signature-rich-editor/signature-rich-editor.component';
import { ContactService } from '../../../components/contact/contact.service';
import { NgxColorsModule } from 'ngx-colors';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { EditShortcutDirective } from '../../../directives/edit-shortcut.directive';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ORGANIZATION,
    component: CrudOrganizationComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ORGANIZATION,
    component: CrudOrganizationComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ORGANIZATION_IDENTITY + '/:id',
    component: CrudOrganizationIdentityComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ORGANIZATION_IDENTITY + '/:id',
    component: CrudOrganizationIdentityComponent,
  },
];

@NgModule({
  declarations: [CrudOrganizationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    EditShortcutDirective,
    FusePipesModule,
    DisplayHtmlLinkPipeModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    MatFormFieldModule,
    NgxPermissionsModule,
    MatInputModule,
    MatProgressBarModule,
    NgxColorsModule,
    AddressComponent,
    ContactComponent,
    SignatureRichEditorComponent,
    MultiSelectModule,
    RouterModule.forChild(routes),
    FileUploadModule,
    FuseWidgetModule,
  ],
  exports: [CrudOrganizationComponent],
  providers: [CrudOrganizationService, ContactService, Gt2LocaleService],
})
export class CrudOrganizationModule {}
